import { render, staticRenderFns } from "./CreateFileEnv.vue?vue&type=template&id=72c5fbd1&"
import script from "./CreateFileEnv.vue?vue&type=script&lang=js&"
export * from "./CreateFileEnv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports